import { h, defineComponent } from 'vue';
import { goBack } from '@/ui/helpers/uiHelper';
import { Button } from '../Button';

export const BackButton = defineComponent({
  name: 'BackButton',
  setup() {
    return function render() {
      return h(Button, {
        props: { type: 'is-light', btnClass: 'back-button' },
        on: {
          click: goBack,
        },
        attrs: {
          iconRight: 'arrow-left',
          iconPack: 'far',
        },
      });
    };
  },
});
